import React from 'react';

import NewsPanel from '../news/NewsPanel.jsx';
import BookPanel from '../commons/components/book/BookPanel.jsx';
import CategoriesPanel from '../commons/components/book/CategoriesPanel';

const BookPage = () => (
  <div className="book-parent scroll-natif">
    <NewsPanel/>
    <CategoriesPanel/>
    <BookPanel/>
  </div>
);

export default BookPage;



// WEBPACK FOOTER //
// ./book/src/book/BookPage.jsx